// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-import-step-header-copy {
  width: 80%;
}
.ct-import-step-header-copy > p,
.ct-import-step-header-copy div {
  margin-bottom: 2rem;
}
.ct-import-step-header-copy ul {
  list-style-position: inside;
}

.import-complete-modal .import-complete-copy .import-complete-header {
  margin-bottom: 1.5rem;
}
.import-complete-modal .import-complete-copy .import-error > div {
  margin-bottom: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ImportCatalogStep/index.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AACE;;EAEE,mBAAA;AACJ;AAEE;EACE,2BAAA;AAAJ;;AAMI;EACE,qBAAA;AAHN;AAOM;EACE,qBAAA;AALR","sourcesContent":[".ct-import-step-header-copy {\n  width: 80%;\n\n  > p,\n  div {\n    margin-bottom: 2rem;\n  }\n\n  ul {\n    list-style-position: inside;\n  }\n}\n\n.import-complete-modal {\n  .import-complete-copy {\n    .import-complete-header {\n      margin-bottom: 1.5rem;\n    }\n\n    .import-error {\n      > div {\n        margin-bottom: 1.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
